<template>
</template>

<script>
import { login, isLoggedIn } from '../utils/auth';

export default {
  name: 'login',
  data() {
    return {};
  },

  mounted() {
    if (isLoggedIn()) {
      this.$router.push('summary');
    } else {
      login();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue